import { Card, Grid, Stack, Typography } from "@compass/core";
import { Select } from "components";
import {
  SurveyExportResource
} from "generated/openApi";
import { useNavigate } from "react-router-dom";

type SurveyExportBodyProps = {
  surveyId: number | undefined;
  exportTypeId: number | undefined;
  setSurveyId: (value: number) => void;
  setExportTypeId: (value: number) => void;
  viewResource: SurveyExportResource;
};

export const CobroSurveyExportBody = ({ surveyId, exportTypeId, setSurveyId, setExportTypeId, viewResource }: SurveyExportBodyProps) => {
  const navigate = useNavigate();

  return (
    <Grid container spacing="lg">
      <Grid item xs={12}>
        <Card>
          <Stack display="flex" direction={"column"} spacing="md">
            <Typography>Survey Exports</Typography>
            <Select
              label="Survey"
              value={viewResource?.surveys?.find((x) => x.id === surveyId)}
              options={viewResource?.surveys}
              getOptionLabel={(option) => option.name}
              onChange={(e, value) => {
                setSurveyId(value.id)
              }}
            />
            <Select
              label="Export Type"
              value={viewResource?.exportTypes?.find((x) => x.id === exportTypeId)}
              options={viewResource?.exportTypes}
              getOptionLabel={option => option.name}
              onChange={(e, value) =>
                setExportTypeId(value.id)
              }
            />
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
};
